import React from 'react'

export function PiCheck() {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9999 25.6667C17.2216 25.6667 20.1382 24.3608 22.2495 22.2496C24.3607 20.1383 25.6666 17.2216 25.6666 14C25.6666 10.7784 24.3607 7.86169 22.2495 5.75041C20.1382 3.63917 17.2216 2.33333 13.9999 2.33333C10.7783 2.33333 7.86162 3.63917 5.75034 5.75041C3.63909 7.86169 2.33325 10.7784 2.33325 14C2.33325 17.2216 3.63909 20.1383 5.75034 22.2496C7.86162 24.3608 10.7783 25.6667 13.9999 25.6667Z'
        fill=''
        stroke='#4E586D'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M9.33325 14L12.8333 17.5L19.8333 10.5'
        stroke='#4E586D'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
